export enum EProgressType {
  success,
  progress,
  error,
}
